import { useEffect, useState } from "react";

export const useGetPositionOfDropDown = (
  dropdownRef,
  tableRef,
  isCountriesDropDownOpen,
) => {
  const [positionLeft, setPositionLeft] = useState("0px");
  const minRightOffset = 48;

  useEffect(() => {
    const updatePosition = () => {
      if (isCountriesDropDownOpen && dropdownRef.current && tableRef.current) {
        const boxTableSellRect = dropdownRef.current.getBoundingClientRect();
        const transitionBoxWidth = dropdownRef.current
          .querySelector(".dropDown")
          .getBoundingClientRect().width;
        const screenWidth = window.innerWidth;

        // Get table coordinates
        const tableRect = tableRef.current.getBoundingClientRect();

        // Calculate the left position relative to the beginning of the table
        let calculatedLeft = boxTableSellRect.left - tableRect.left + 50;

        if (screenWidth < 980) {
          calculatedLeft = calculatedLeft - 30;
        }

        // Check that the dropdown does not extend beyond the right edge of the screen
        if (boxTableSellRect.left + transitionBoxWidth + 20 > screenWidth) {
          calculatedLeft = screenWidth - transitionBoxWidth - minRightOffset;
        }

        setPositionLeft(`${calculatedLeft}px`);
      }
    };

    //Update the position when opening and when resizing the screen
    updatePosition();

    window.addEventListener("resize", updatePosition);

    return () => {
      window.removeEventListener("resize", updatePosition);
    };
  }, [isCountriesDropDownOpen]);

  return { positionLeft };
};
